import ar_LB from './ar_LB.json';
import en_GB from './en_GB.json';

const messages = {
  'en-GB': en_GB,
  'ar-LB': ar_LB,
};

export default messages;
